const CallTableServerUseCase = {
  execute() {
    window.parent.postMessage({ eventName: 'call_server' }, '*');
  }
};

export default CallTableServerUseCase;
